import React from "react";

export interface AscOptionProps {
  className?: string;
  icon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  label: string;
  value: string;
  disabled?: boolean;
  hideArrowIcon?: boolean;
}

export default function AscOption({ label }: AscOptionProps) {
  return <>{label}</>;
}
